<template>
  <modal
    name="deleteMyAccount"
    modal-style="compact"
    :display-header-title="false"
  >
    <delete-account />
  </modal>
</template>


<script>
  import DeleteAccount from './delete-account/index.vue';


  export default {
    name: 'DeleteAccountModal',

    components: {
      DeleteAccount
    }
  };
</script>
